import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import { InvalidTonnageModel } from "../../InvalidCheck/models/InvalidTonnageModel";
import TonnageModel from "../models/TonnageModel";
import TonnageNameModel from "../models/TonnageNameModel";
import TonnageOperatorHistoryModel from "../models/TonnageOperatorHistory";
import TonnageQueryModel from "../models/TonnageQueryModel";

export interface SearchTonnageParam {
    pageSize: number,
    query: TonnageQueryModel
}

export interface SaveTonnageParam {
    id: string,
    vesselName: string,
    portOpen: number,
    dateOpenStart: string,
    dateOpenEnd: string,
    dwt: number,
    yearBuilt: number,
    class: string,
    deck: string,
    loa: number,
    beam: number,
    draft: number,
    gear: number,
    grabs: boolean,
    gearless: boolean,
    operator: string,
    headOwner: string,
    remarks: string,
    capacity: number,
    fullTC: string,
    updateFullTc: boolean,
    updateModifiedDate: boolean,
}

export interface CorrectInvalidTonnageParam {
    id: string,
    portOpen: number,
    operator: string,
    headOwner: string,
}

export interface GetTonnageByIdParam {
    id: string,
}

export interface MergeDuplicateTonnageItemParam {
    targetTonnageId: string,
    mergeTonnageIds: string[],
}

export interface MergeDuplicateTonnageParam {
    mergeItems: MergeDuplicateTonnageItemParam[],
}

export interface DeleteTonnageParam {
    id: string
}

export interface ParseFullTcParam {
    fullTc: string
}

export interface TonnageImportModel {
    tonnageId: string;
    vesselName: string;
    openArea: string;
    portOpen: number;
    dateOpenStart: string;
    dateOpenEnd: string;
    portNameCurrent: string;
    dateOpenStartCurrent?: string;
    dateOpenEndCurrent?: string;
    validationErrors?: string[];
}

const axiosConfig = {
    headers: {
        ignoreCredentials: true
    }
};

const TonnageApi = {
    Search(param: SearchTonnageParam) {
        return Api.post<SearchTonnageParam, BaseResponse<TonnageModel[]>>("/api/tonnage/Search", param);
    },
    Save(param: SaveTonnageParam) {
        return Api.post<SaveTonnageParam, BaseResponse<TonnageModel>>("/api/tonnage/Save", param);
    },
    GetAllNames() {
        return Api.get<null, BaseResponse<TonnageNameModel[]>>("/api/tonnage/GetAllNames", null);
    },
    GetById(param: GetTonnageByIdParam) {
        return Api.get<GetTonnageByIdParam, BaseResponse<TonnageModel>>("/api/tonnage/GetById", param);
    },
    GetFullTc(url: string) {
        return Api.get<unknown, string>(url, null, axiosConfig);
    },
    GetOperatorHistory(param: GetTonnageByIdParam) {
        return Api.get<GetTonnageByIdParam, BaseResponse<TonnageOperatorHistoryModel[]>>("/api/tonnage/GetOperatorHistory", param);
    },
    GetDuplicateTonnages() {
        return Api.get<null, BaseResponse<TonnageModel[]>>("/api/tonnage/GetDuplicateTonnages", null);
    },
    MergeDuplicateTonnage(param: MergeDuplicateTonnageParam) {
        return Api.post<MergeDuplicateTonnageParam, BaseResponse<TonnageModel[]>>("/api/tonnage/MergeDuplicateTonnage", param);
    },
    Delete(param: DeleteTonnageParam) {
        return Api.post<DeleteTonnageParam, BaseResponse<TonnageModel[]>>("/api/tonnage/Delete", param);
    },
    GetInvalidTonnages() {
        return Api.get<null, BaseResponse<InvalidTonnageModel[]>>("/api/tonnage/GetInvalidTonnages", null);
    },
    CorrectInvalid(param: CorrectInvalidTonnageParam) {
        return Api.post<CorrectInvalidTonnageParam, BaseResponse<TonnageModel>>("/api/tonnage/CorrectInvalid", param);
    },
    ParseFullTc(param: ParseFullTcParam) {
        return Api.post<ParseFullTcParam, BaseResponse<TonnageModel>>("/api/tonnage/ParseFullTc", param);
    },
    ImportTonnageFromExcel(file: File) {
        const formData = new FormData();
        formData.append('file', file);
        return Api.postForm<BaseResponse<TonnageImportModel[]>>("/api/tonnage/ImportTonnageFromExcel", formData);
    },
    ValidateImportData(importData: TonnageImportModel[]) {
        return Api.post<TonnageImportModel[], BaseResponse<TonnageImportModel[]>>("/api/tonnage/ValidateImportData", importData);
    },
    SaveImportData(importData: TonnageImportModel[]) {
        return Api.post<TonnageImportModel[], BaseResponse<string>>("/api/tonnage/SaveImportData", importData);
    },
};
export default TonnageApi;